import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

export type ToastPayload = {
  id: string;
  title: React.ReactNode;
  message: React.ReactNode;
  variant: 'success' | 'warning' | 'error' | 'info';
  closable?: boolean;
  duration?: number;
};

export const toastAdapter = createEntityAdapter<ToastPayload>();

const initialState = toastAdapter.getInitialState();

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: {
      reducer: toastAdapter.addOne,
      prepare: (payload: Omit<ToastPayload, 'id'> & { id?: string }) => ({
        payload: {
          ...payload,
          id: payload.id || uuidv4(),
        },
      }),
    },
    removeToast: toastAdapter.removeOne,
  },
});

export const { showToast, removeToast } = toastSlice.actions;
export default toastSlice.reducer;
